<template>
  <div v-loading="loading">
    <a-form-model ref="ruleForm" :model="form" :rules="rules" labelAlign="right" :label-col="{span: 4}" :wrapper-col="{span: 14}">
      <a-row>
        <a-col :span="8">
          <a-form-model-item label="模板名称" prop="template_name" >
            <a-input v-model="form.template_name" allowClear placeholder="请输入模板名称" />
          </a-form-model-item>
        </a-col>
        <a-col :span="16">
          <a-form-model-item label="关键词名称" prop="replace_keyword" :label-col="{span: 2}" :wrapper-col="{span: 22}">
            <a-input v-model="form.replace_keyword" allowClear placeholder="请输入模板名称" style="width: 32%"/>
            <span style="margin-left:10px;" v-text="'请使用英文的 {{XXX}} 来代替标签变量，例如 {{商标类}}'"></span>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="发布平台" prop="line_id">
            <a-select v-model="form.line_id" allowClear show-search option-filter-prop="children" placeholder="请选择">
              <a-select-option v-for="item in platformList" :key="item.id" :value="item.id">{{ item.org }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="文章分类" prop="typeid">
            <a-select v-model="form.typeid" allowClear show-search option-filter-prop="children" placeholder="请选择">
              <a-select-option v-for="item in classifyList" :key="item.id" :value="item.id">{{ item.path_name }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="发布者" prop="publisher_id">
            <a-select v-model="form.publisher_id" allowClear show-search option-filter-prop="children" placeholder="请选择">
              <a-select-option v-for="item in authorList" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="作者" prop="author">
            <a-input v-model="form.author" allowClear placeholder="请输入作者名称"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="随机阅读数" prop="is_rand">
            <a-radio-group v-model="form.is_rand">
              <!-- 'is_rand'         => '是否随机生成阅读数 0否 1是', -->
              <a-radio value="1"> 是 </a-radio>
              <a-radio value="0" style="margin-left:40px;"> 否 </a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col :span="24">
          <a-form-model-item label="文章标题" :label-col="{span: 1}" :wrapper-col="{span: 19}" prop="title">
            <a-input v-model="form.title" allowClear placeholder="请输入文章标题"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="小标题" :label-col="{span: 1}" :wrapper-col="{span: 19}" prop="title2">
            <a-input v-model="form.title2" allowClear placeholder="请输入小标题"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="关键词" :label-col="{span: 1}" :wrapper-col="{span: 19}" prop="keywords">
            <a-input v-model="form.keywords" allowClear placeholder="请输入关键词"/>
          </a-form-model-item>
        </a-col>
      </a-row>

      <!-- 文章内容 -->
      <a-row>
        <a-col span="24">
          <a-form-model-item label="内容" labelAlign="left" prop="content" :label-col="{span: 1}" :wrapper-col="{span: 20}">
            <div class="flex">
              <Editor v-model="form.content" style="width: 900px" />
            </div>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :wrapper-col="{span: 20, offset: 1}">
            <a-button :loading="submitLoading" class="mr20" type="primary" @click="handleSubmit">保 存</a-button>
            <a-button @click="close">取 消</a-button>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>

  </div>
</template>
<script>
import Editor from '@/components/Editor1/Editor.vue'
import { reactive, onMounted, toRefs, computed, watch, getCurrentInstance, ref } from '@vue/composition-api'
import api from '@/api/'

export default {
  components: {
    Editor,
  },
  setup(props, { root }) {
    const _this = getCurrentInstance()
    const isEdit = computed(() => !!_this.$route.params.id)

    const state = reactive({
      form: {
        id: undefined,
        template_name: '',
        replace_keyword: '',
        line_id: '',
        typeid: '',
        publisher_id: '',
        author: '',
        is_rand: '',
        title: '',
        title2: '',
        keywords: '',
        content: ''
      },
      rules: {
        template_name: [{ required: true, message: '请输入', trigger: ['blur', 'change'] }],
        replace_keyword: [{ required: true, message: '请输入', trigger: ['blur', 'change'] }],
        line_id: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
        typeid: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
        publisher_id: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
        author: [{ required: true, message: '请输入', trigger: ['blur', 'change'] }],
        is_rand: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
        title: [{ required: true, message: '请输入', trigger: ['blur', 'change'] }],
        title2: [{ required: true, message: '请输入', trigger: ['blur', 'change'] }],
        keywords: [{ required: true, message: '请输入', trigger: ['blur', 'change'] }],
        content: [{ required: true, message: '请输入', trigger: ['blur', 'change'] }],
      },
      // titleHtml: '',
      contentHtml: '',
      submitLoading: false,
      line_idPlatformList: [],
      authorList: [],
      platformList: [],
      classifyList: [],
      loading: false
    })

    // watch(
    //   () => state.form.title,
    //   () => {
    //     if (state.form.title === '') {
    //       _this.titleHtml = ''
    //     }
    //   }
    // )

    watch(
      () => state.form.content,
      () => {
        if (state.form.content === '') {
          _this.contentHtml = ''
        }
      }
    )

    onMounted(() => {
      _this.form.id = _this.$route.query.id
      _this.form.id && _this.loadDetail()
      _this.getPlatform()
      _this.getArticleClassify()
      _this.getPublisher()
    })

    // // 获取平台列表
    // async function getPlatformList(line_id) {
    //   const res = await api.LineListNew()
    //   const options = res.data
    //   const b = options.find(item => item.id === line_id)
    //   state.line_idPlatformList.push(b)
    //   getDepartment(options, parseInt(b.id))
    // }
    // // 过滤平台列表
    // function getDepartment(options, line_id) {
    //   options.map(item => {
    //     if (item.parent_id === line_id) {
    //       state.line_idPlatformList.push(item)
    //       getDepartment(options, parseInt(item.id))
    //     }
    //   })
    // }

    // 启动滚动
    function startScroll(dom) {
      // const wap = _this.$refs.wap
      // _this.$nextTick(() => {
      //   new BetterScroll('.' + dom, {})
      // })
    }

    async function loadDetail() {
      _this.loading = true
      const res = await api.articleTemplateItems({ id: _this.form.id }).finally(() => {
        _this.loading = false
      })
      if (res.code === '000000') {
        const detail = res?.data?.list ? res.data.list[0] : {}
        _this.form = detail
        Object.keys(_this.form).forEach(key => {
          _this.form[key] = detail[key]
          if (key === 'line_id') {
            _this.form[key] = String(detail[key])
          }
          if (key === 'typeid' || key === 'publisher_id') {
            _this.form[key] = Number(detail[key])
          }
        })
        _this.form.publisher_id = _this.form?.publisher_id || undefined
      }
    }

    async function handleSubmit() {
      _this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
        // console
          _this.submitLoading = true
          const apiAction = _this.form.id ? api.articleTemplateUpdate : api.articleTemplateCreate
          const res = await apiAction(_this.form).finally(() => {
            _this.submitLoading = false
          })
          if (res.code === '000000') {
            this.$message.success('保存成功')
            _this.close()
          }
        }
      })
    }

    function close() {
      _this.$router.push('/article/choosetemplate')
    }

    // 获取发布平台列表
    async function getPlatform() {
      const res = await api.LineListNew()
      state.platformList = res.data.filter(item => {
        if (item.parent_id === 0) {
          return item
        }
      })
    }

    // 获取文章分类
    async function getArticleClassify() {
      const res = await api.listClassify()
      state.classifyList = res?.data?.articleType
    }

    // 获取发布者
    async function getPublisher () {
      const res = await api.listPublisher()
      state.authorList = res.data.articleAuthor
    }

    return {
      ...toRefs(state),
      isEdit,
      startScroll,
      handleSubmit,
      getPlatform,
      getArticleClassify,
      getPublisher,
      close,
      loadDetail
    }
  }
}
</script>

<style lang="less" scoped>
.tailor-img {
  width: 100px;
  height: 100px;
  cursor: pointer;
}

.img-default {
  width: 100px;
  height: 100px;
  background-color: #f5f7fa;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pc-preview {
  background-color: orange;
  position: fixed;
  width: 100%;
  height: 100%;
}
</style>
<style lang="less">
.pc-container {
  width: 100%;
  height: 700px;
  overflow-y: auto;
  /deep/img {
    width: 100%;
    height: auto;
  }
}
.wap-container {
  width: 375px;
  height: 667px;
  overflow-y: auto;
}
.preViewWap {
  /deep/img {
    width: 100%;
    height: auto;
  }
}
</style>
